<template>
  <div>
    <div v-if="!this.$route.params.id" class="text-h6" style="margin: 20px">New club</div>
    <div v-else class="text-h6" style="margin: 20px">Update club</div>
    <v-card color="grey lighten-4" style="margin: 20px; padding: 20px">
      <v-card-text style="width: 90%; margin: 0 auto">
        <v-text-field v-model="name" :rules="[textfieldRules.required]" label="Name"></v-text-field>
        <v-text-field v-model="governor" :rules="[textfieldRules.required]" label="Governor"></v-text-field>
        <v-row>
          <v-col>
            <v-select
              v-model="organization"
              label="Organization"
              :items="getOrganizations"
              item-text="name"
              item-value="id"
              persistent-hint
            ></v-select
          ></v-col>
          <v-col>
            <v-select
              label="Entity Type"
              v-model="entityType"
              :items="getEntityTypes"
              item-text="name"
              item-value="id"
              persistent-hint
            ></v-select
          ></v-col>
        </v-row>
        <v-file-input
          id="imageInput"
          @change="onFileChange"
          label="Logo image"
          v-model="imageFile"
          style="display: none"
        ></v-file-input>
        <v-row id="imageRow">
          <v-col>
            <img
              v-if="this.hasImage"
              :src="this.image"
              id="image"
              alt="Logo image"
              style="width: 60%; min-width: 100px"
            />
            <v-icon size="80" v-else>mdi-image</v-icon>
          </v-col>
          <v-col>
            <v-btn style="margin: 10%" elevation="0" @click="this.imageAction">
              {{ this.hasImage ? 'Delete picture' : 'Add picture' }}
            </v-btn>
          </v-col>
        </v-row>
        <v-checkbox v-model="active" label="Is Active"></v-checkbox>
        <div class="text-subtitle-1" style="color: red; margin-left: 10px">{{ this.errorText }}</div>
      </v-card-text>
      <div class="ml-2">
        <v-btn @click="saveAndExit()" style="margin: 20px">
          <!-- <v-progress-circular indeterminate v-if="this.isLoading"></v-progress-circular> -->
          <div>Save and exit</div>
        </v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
  import {
    GET_ORGANIZATIONS,
    GET_ENTITY_TYPES,
    GET_ENTITIES,
    ADD_OR_UPDATE_CLUB,
  } from '../../../graphql/organizationQueries';
  import { toBase64 } from '../../../utils/Helper.js';

  export default {
    created() {
      this.populateData();
    },
    data() {
      return {
        name: '',
        governor: '',
        image: null,
        imageFile: null,
        active: false,
        jsonData: {},
        club: null,
        organization: null,
        entityType: null,
        errorText: '',
        textfieldRules: {
          required: (value) => !!value || 'required field',
        },
        getOrganizations: [],
        getEntityTypes: [],
      };
    },
    apollo: {
      $client: 'organizationClient',
      getOrganizations: {
        query: GET_ORGANIZATIONS,
        loadingKey: 'loading',
      },
      getEntityTypes: {
        query: GET_ENTITY_TYPES,
        loadingKey: 'loading',
      },
    },
    computed: {
      hasImage: function () {
        return this.imageFile != null;
      },
    },
    methods: {
      async populateData() {
        const id = this.$route.params.id;
        if (id) {
          this.club = await this.$apollo
            .query({
              query: GET_ENTITIES,
              variables: {
                id: id,
              },
            })
            .then((response) => {
              const result = response.data.getEntities;
              if (result.length > 0) return result[0];
              return null; // Query returns an array, we take first element since we use specific ID
            })
            .catch((error) => {
              throw error;
            });
          if (this.club) {
            this.name = this.club.name;
            this.governor = this.club.governorEntityId;
            this.jsonData = this.club.jsonData;
            this.active = this.club.active;
            this.image = this.club.image;

            //Fetch organization and entitytpes in order to add them to select list if they are set.
            if (this.club.organizationId) {
              const orgList = await this.$apollo.queries.getOrganizations.refetch();
              this.organization = orgList.data.getOrganizations.filter((org) => org.id === this.club.organizationId)[0];
            }

            if (this.club.entityTypeId) {
              const etyList = await this.$apollo.queries.getEntityTypes.refetch();
              this.entityType = etyList.data.getEntityTypes.filter((ety) => ety.id === this.club.entityTypeId)[0];
            }

            if (this.image) {
              fetch(this.image)
                .then((res) => res.blob())
                .then((blob) => {
                  this.imageFile = new File([blob], 'fileName', { type: 'image/png' });
                });
            }
          }
        }
      },
      async saveAndExit() {
        //Validate form
        if (this.name == '' || this.governor == '' || this.organization == null || this.entityType == null) {
          this.errorText = 'Please fill in all required fields.';
          return;
        }
        try {
          let base64Image = null;
          if (this.imageFile) {
            base64Image = await toBase64(this.imageFile);
          }
          let orgID = this.organization;
          let ettyID = this.entityType;

          //Organization is stored as object if it is unchanged. set to id.
          if (this.organization.id) {
            orgID = this.organization.id;
          }

          if (this.entityType.id) {
            ettyID = this.entityType.id;
          }

          let clubJson = {
            name: this.name,
            active: this.active,
            governorEntityId: this.governor,
            organizationId: orgID,
            entityTypeId: ettyID,
            image: base64Image,
            jsonData: this.jsonData,
          };

          if (this.$route.params.id) {
            clubJson.id = this.$route.params.id;
          }

          const result = await this.$apollo.mutate({
            mutation: ADD_OR_UPDATE_CLUB,
            variables: {
              entity: clubJson,
            },
          });

          if (result.data.addOrUpdateEntity) {
            this.errorText = '';
            this.$router.push({ path: '/clubs' });
          }

          this.errorText = 'Something went wrong with the database connection';
        } catch (err) {
          console.log('Error adding/updating organization! ' + err.message);
          this.errorText = 'Something went wrong with the database connection';
        }
      },
      imageAction() {
        if (this.hasImage) {
          //Delete image
          this.image = null;
          this.imageFile = null;
        } else {
          //Add image
          document.getElementById('imageInput').click();
        }
      },
      async onFileChange(file) {
        if (!file) {
          return;
        }
        this.image = await toBase64(file);
      },
    },
  };
</script>

<style scoped>
  @media only screen and (max-width: 800px) {
    #imageRow {
      width: 100%;
    }
  }

  @media only screen and (min-width: 800px) {
    #imageRow {
      width: 400px;
    }
  }
</style>
